import { merge, groupBy, slice, find, addIndex } from 'ramda';
import {
    PAGE_UPDATE,
    TEETIMES_FETCHED,
    TEETIMES_FETCHING,
    MOBILE_LOAD_MORE,
    DRAWER_CLOSED,
    DRAWER_OPENED,
    TEETIME_SELECTED,
    CANCEL_SELECTED_TEETIME,
} from '../actions';

const hasUpdated = (a, b) =>
    a.length !== b.length
        ? true
        : addIndex(find)((val, index) => val !== b[index], a) ? true : false

const cacheHotDeals = state => {
    const mobilePageSize = 5;
    const { hotDeals } = state;
    const tempHotDeals = slice(0, mobilePageSize * 1, hotDeals);
    const mobileVisibleTimes = slice(0, (hotDeals.length >= mobilePageSize ? 0 : mobilePageSize - hotDeals.length) * 1, state.teeTimes);
    return { ...state, mobileVisibleTimes, cachedHotDeals: hotDeals, hotDeals: tempHotDeals }
}

function teetimes(state = {
    isFetching: false,
    teeTimes: [],
    hotDeals: [],
    currentPage: 1,
    numberOfPages: 1,
    pageSize: 10,
    mobilePageSize: 15,
    visibleTimes: [],
    mobileVisibleTimes: [],
    cachedHotDeals: null,
    mobilePage: 1,
}, action) {
    switch (action.type) {
        case TEETIMES_FETCHING:
            return merge(state, { isFetching: true });
        case TEETIMES_FETCHED: {
             const {
                hotDeals = [],
                teeTimes = []
            } = groupBy(teetime => teetime.isHotDeal ? 'hotDeals' : 'teeTimes', action.payload);
            const numberOfPages = Math.ceil(teeTimes.length / state.pageSize) || 1;
            const visibleTimes = slice(0, state.pageSize, teeTimes)
            const mobileVisibleTimes = slice(0, state.mobilePageSize, teeTimes)
            const mobilePage = 1;
            return merge(state, {
                // helps with rendering performance if we keep old array reference if none of the items have changed
                teeTimes: hasUpdated(teeTimes, state.teeTimes) ? teeTimes : state.teeTimes,
                hotDeals: hasUpdated(hotDeals, state.hotDeals) ? hotDeals : state.hotDeals,
                numberOfPages,
                isFetching: false,
                currentPage: 1,
                visibleTimes: hasUpdated(visibleTimes, state.visibleTimes) ? visibleTimes : state.visibleTimes,
                mobileVisibleTimes,
                mobilePage
            });
        }
        case PAGE_UPDATE: {
            const { currentPage } = action.payload
            const { pageSize, teeTimes } = state
            const visibleTimes = slice((currentPage - 1) * pageSize, currentPage * pageSize, teeTimes)
            return merge(state, { currentPage, visibleTimes });
        }
        case MOBILE_LOAD_MORE: {
            const mobilePage = state.mobilePage + 1
            const mobileVisibleTimes = slice(0, state.mobilePageSize * mobilePage, state.teeTimes)
            return merge(state, { mobilePage, mobileVisibleTimes });
        }
        // Please forgive me for this Blasphemy but due to the limited access to the parent Iframe we need to control the size of the page when modals/drawers are opened
        case DRAWER_OPENED: {
            return cacheHotDeals(state);
        }
        case DRAWER_CLOSED: {
            const mobileVisibleTimes = slice(0, state.mobilePageSize * state.mobilePage, state.teeTimes)
            return { ...state, mobileVisibleTimes, cachedHotDeals: undefined, hotDeals: state.cachedHotDeals}
        }
        case TEETIME_SELECTED: {
            // only in the case this is a mobile modal and the qty selector is going to be shown
           return action.isMobileModal ? cacheHotDeals(state) : state;
        }
        case CANCEL_SELECTED_TEETIME: {
            // we can assume that the cache exist here sincce the modal would have been opened
            // we do not not need to do anything in the case of a teetime being selected because on success the app re-routes and on failure the app
            // makes a new request for tee-times which will reset everything
            const mobileVisibleTimes = slice(0, state.mobilePageSize * state.mobilePage, state.teeTimes)
            return { ...state, mobileVisibleTimes, cachedHotDeals: undefined, hotDeals: state.cachedHotDeals}
        }
        default:
            return state;
    }
}

export default teetimes;


// WEBPACK FOOTER //
// ./src/reducers/teetimes.js